"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_table_1 = require("react-table");
var layout_1 = require("../util/layout");
var helpers_1 = require("../util/helpers");
var typography_1 = require("./typography");
var TableStyle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  ", "\n  ", "\n\n  .thead .tr .th {\n    padding-bottom: ", ";\n    border-bottom: 1px solid ", ";\n    text-align: left;\n    font-weight: 700;\n    color: ", ";\n    text-transform: uppercase;\n  }\n\n  .tbody .tr {\n    overflow: hidden;\n    ", "\n\n    .td {\n      align-items: center;\n      justify-content: flex-start;\n      display: flex;\n      padding: ", " ", " ", " 0;\n      border-bottom: 1px solid ", ";\n      min-height: ", ";\n    }\n  }\n"], ["\n  width: 100%;\n  ", "\n  ", "\n\n  .thead .tr .th {\n    padding-bottom: ", ";\n    border-bottom: 1px solid ", ";\n    text-align: left;\n    font-weight: 700;\n    color: ", ";\n    text-transform: uppercase;\n  }\n\n  .tbody .tr {\n    overflow: hidden;\n    ", "\n\n    .td {\n      align-items: center;\n      justify-content: flex-start;\n      display: flex;\n      padding: ", " ", " ", " 0;\n      border-bottom: 1px solid ", ";\n      min-height: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (0, typography_1.fontSize)(1, theme.typography.baseSize);
}, function (_a) {
    var theme = _a.theme;
    return (0, helpers_1.passThroughRule)('font-family', theme.typography.baseType);
}, (0, layout_1.space)(1), function (_a) {
    var theme = _a.theme;
    return theme.colors.grayBorder;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray;
}, function (_a) {
    var rowsClickable = _a.rowsClickable;
    return (rowsClickable ? 'cursor: pointer;' : '');
}, (0, layout_1.space)(1), (0, layout_1.space)(1), (0, layout_1.space)(1), function (_a) {
    var theme = _a.theme;
    return theme.colors.grayBorder;
}, (0, layout_1.space)(8));
var CellContents = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  ", "\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  ", "\n"])), function (_a) {
    var wrapText = _a.wrapText;
    return (wrapText ? '' : 'white-space: nowrap;');
});
var Table = function (_a) {
    var cols = _a.cols, data = _a.data, onRowClick = _a.onRowClick, _b = _a.defaultColumn, defaultColumn = _b === void 0 ? {} : _b;
    var _c = (0, react_table_1.useTable)({
        columns: cols,
        data: data,
        defaultColumn: (0, react_1.useMemo)(function () { return (__assign({ width: 50, minWidth: 10, maxWidth: 300, wrap: true }, defaultColumn)); }, []),
    }, react_table_1.useFlexLayout), getTableProps = _c.getTableProps, getTableBodyProps = _c.getTableBodyProps, headerGroups = _c.headerGroups, rows = _c.rows, prepareRow = _c.prepareRow;
    return (react_1.default.createElement(TableStyle, { rowsClickable: !!onRowClick },
        react_1.default.createElement("div", __assign({}, getTableProps(), { className: "table" }),
            react_1.default.createElement("div", { className: "thead" }, headerGroups.map(function (headerGroup) { return (react_1.default.createElement("div", __assign({ className: "tr" }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) { return (react_1.default.createElement("div", __assign({ className: "th" }, column.getHeaderProps()),
                react_1.default.createElement(CellContents, { wrapText: column.wrap }, column.render('Header')))); }))); })),
            react_1.default.createElement("div", __assign({ className: "tbody" }, getTableBodyProps()), rows.map(function (row, i) {
                prepareRow(row);
                return (react_1.default.createElement("div", __assign({ className: "tr" }, row.getRowProps(), { onClick: onRowClick
                        ? function (e) { return onRowClick(e, row.original); }
                        : null }), row.cells.map(function (cell) { return (react_1.default.createElement("div", __assign({ className: "td" }, cell.getCellProps()),
                    react_1.default.createElement(CellContents, { wrapText: cell.column.wrap }, cell.render('Cell')))); })));
            })))));
};
exports.default = Table;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Table.js.map